import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCustomer } from "@lib/context/shared/customer-context";
import mixpanelService from "@lib/mixpanel/mixpanel.service";
const useTrackEvent = () => {
  const {
    getLoggedCustomer
  } = useCustomer();
  const trackEvent = function (eventName) {
    let eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let customCustomer = arguments.length > 2 ? arguments[2] : undefined;
    const customer = customCustomer !== null && customCustomer !== void 0 ? customCustomer : getLoggedCustomer();
    try {
      if (!customer) {
        console.warn("Event ".concat(eventName, " not tracked: No logged-in customer found"));
        return;
      }
      const defaultEventProperties = _objectSpread({
        Name: "".concat(customer.first_name, " ").concat(customer.last_name),
        Email: customer.email
      }, eventProperties);
      mixpanelService.trackEvent(eventName, defaultEventProperties, customer);
    } catch (error) {
      console.error("Failed event ".concat(eventName, ":"), error);
    }
  };
  return trackEvent;
};
export default useTrackEvent;